import { SearchOutlined } from '@ant-design/icons';
import classNames from 'classnames';

import Button from '~/shared/components/form-fields/button';

type GetSearchPostFormConfigProps = {
  lng: string;
  t: (key: string) => string;
  searchRef: React.RefObject<HTMLInputElement | null>;
  searchValue: string;
  onSearchValueChange: (value: string) => void;
};

const getSearchPostFormConfig = ({ t, searchRef, searchValue, onSearchValueChange }: GetSearchPostFormConfigProps) => {
  return {
    name: 'searchPost',
    pattern: 'basicFormPattern',
    initialValues: {
      postTitle: '',
    },
    position4: {
      formFields: [
        {
          name: 'postTitle',
          className: 'search-bar-view__post-title-field',
          placeholder: t('field.post-title.title'),
          ref: searchRef,
          type: 'text',
          config: {
            onChange: ({ value }: { value: unknown }) => {
              onSearchValueChange(String(value ?? ''));
            },
          },
        },
      ],
      buttons: [
        {
          name: 'submit',
          htmlType: 'submit',
          render: ({ key }: { key: string }) => (
            <Button
              key={key}
              size="large"
              className={classNames('search-bar-view__search-icon', 'action-button--yellow', {
                'search-bar-view__search-icon--disabled': searchValue.trim().length < 4,
              })}
              disabled={searchValue.trim().length < 4}
              htmlType="submit"
            >
              <SearchOutlined />
            </Button>
          ),
          config: {
            isBlock: true,
          },
        },
      ],
    },
  };
};

export default getSearchPostFormConfig;
